import { jsx as t } from "react/jsx-runtime";
import { useTabSetItems as i } from "../hooks/useTabSetItems.js";
import { s as o } from "../../../TabSet.module-C8hFDW4m.js";
const m = ({ ...r }) => {
  var l;
  const e = i();
  if (!((l = e == null ? void 0 : e.active) != null && l.panel))
    return null;
  const { id: a, panel: n } = e.active;
  return /* @__PURE__ */ t(
    "div",
    {
      className: o.panel,
      "aria-labelledby": a,
      id: `${a}--panel`,
      role: "tabpanel",
      ...r,
      children: n
    }
  );
};
export {
  m as TabSetPanel
};
